import React from 'react';
import iconNs from '@ant-design/icons';

const Icon = iconNs.default || iconNs;

export function GapGeniusIconComponent() {
  return (
    <svg width='1em' height='1em' viewBox='0 0 1000 1000'>
      <path
        fill='#666'
        d='M694.24 896.52H98.51c-29.67 0-53.81-24.14-53.81-53.81V511.89c0-29.67 24.14-53.81 53.81-53.81h73.22c9.9 0 17.92 8.02 17.92 17.92s-8.02 17.92-17.92 17.92H98.51c-9.9 0-17.96 8.06-17.96 17.96V842.7c0 9.9 8.06 17.96 17.96 17.96h595.73c9.9 0 17.96-8.06 17.96-17.96V511.88c0-9.9-8.06-17.96-17.96-17.96H623.3c-9.9 0-17.92-8.02-17.92-17.92s8.02-17.92 17.92-17.92h70.94c29.67 0 53.81 24.14 53.81 53.81v330.82c0 29.67-24.14 53.81-53.81 53.81z'
        />
      <path
        fill='#f2f2f2'
        d='M171.73 493.93H98.51c-9.9 0-17.96 8.06-17.96 17.96v330.82c0 9.9 8.06 17.96 17.96 17.96h595.73c9.9 0 17.96-8.06 17.96-17.96V511.89c0-9.9-8.06-17.96-17.96-17.96H623.3c-9.9 0-17.92-8.02-17.92-17.92H189.65c0 9.9-8.02 17.92-17.92 17.92z'
        />
      <g fill='#666'>
        <path d='M973.53 279.01c-3.57-10.98-15.36-16.99-26.35-13.43l-65.53 21.29v-68.89c0-11.55-9.36-20.91-20.91-20.91s-20.91 9.36-20.91 20.91v68.89l-65.5-21.28c-10.98-3.57-22.78 2.44-26.35 13.43-3.57 10.98 2.44 22.78 13.42 26.35l65.51 21.29-40.49 55.73c-6.79 9.34-4.72 22.42 4.63 29.21 3.71 2.7 8.01 4 12.27 4 6.47 0 12.84-2.99 16.93-8.62l40.49-55.73 40.49 55.73c4.09 5.63 10.47 8.62 16.93 8.62 4.26 0 8.56-1.3 12.27-4 9.34-6.79 11.41-19.86 4.63-29.21l-40.49-55.73 65.52-21.29c10.98-3.57 16.99-15.37 13.42-26.35zM390.36 233.66l-2.03-.02c-36.98 0-71.86 14.32-98.19 40.32-26.9 26.5-41.7 61.89-41.7 99.65 0 21.39 17.41 38.79 38.8 38.79s38.79-17.4 38.79-38.79c0-16.85 6.59-32.61 18.58-44.41 11.76-11.59 27.01-17.97 42.91-17.97l1.91.04c32.8.43 60.89 28.58 61.33 61.46.25 17.28-4.15 31.47-27.39 52.89-48.95 45.06-73.78 94.2-73.78 146.04 0 21.39 17.41 38.8 38.8 38.8s38.79-17.41 38.79-38.8c0-29.71 15.94-58.81 48.74-88.97 24.81-22.86 53.2-56.14 52.43-111.05-1.05-75.02-62.94-136.91-137.97-137.97zM392.28 650.77c-25.44 0-46.13 20.69-46.13 46.13s20.69 46.13 46.13 46.13 46.11-20.69 46.11-46.13-20.69-46.13-46.11-46.13z' />
      </g>
    </svg>
  );
}

function IconComponent() {
  return (
    <Icon component={GapGeniusIconComponent} />
  );
}

export default IconComponent;
